<div
	[formGroup]="control"
	class="flex flex-col space-y-2.5"
	role="group"
>
	<div class="flex flex-auto flex-shrink-0 flex-col space-y-2.5">
		<ng-container
			*ngTemplateOutlet="editing.value ? editBase : viewBase; context: { $implicit: control }"
		></ng-container>
		<ng-container *ngIf="control.controls.items as items">
			<div class="flex flex-col space-y-6">
				@if(control.controls.enabled.value) {
				<div
					*ngIf="!isWorkspaceSchedule && editing.value"
					class="flex justify-end"
				>
					<div class="mat-bd-20 mat-hint flex h-10 items-center rounded px-3">
						<ng-container *ngTemplateOutlet="totalTime"></ng-container>
					</div>
				</div>
				}
				<div
					[ngClass]="!isWorkspaceSchedule ? '': 'items-center'"
					class="flex flex-col space-y-2.5"
				>
					<ng-container *ngFor="let ctrl of items.controls; let ctrlName = index">
						<ng-container
							*ngTemplateOutlet="(editing.value && control.controls.enabled.value) ? edit : showDetails ? view : null; context: { $implicit: ctrl, name: ctrlName }"
						></ng-container>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
	<ng-template
		#view
		let-ctrl
	>
		<div
			*ngIf="ctrl.value?.enabled && (ctrl.value?.items | viewFilterItems) as times"
			class="flex flex-col"
		>
			<div class="flex flex-col space-y-2">
				<div class="flex items-center space-x-2">
					<div class="font-bold">
						{{ now | dfnsAddDays: ctrl.value.day | dfnsFormat: 'iii' | padRight: 12 }}
					</div>
					<ng-container *ngIf="stats$ | async as s">
						<span class="dot size-1.5"></span>
						<div class="mat-hint text-sm">{{ s.days[ctrl.value.day] | parseMsAsDuration }}</div>
					</ng-container>
				</div>
				<div
					*ngFor="let t of times"
					class="mat-typography flex items-center space-x-2"
				>
					<span>{{ t.from | padRight: 6 : ' ' }}</span>
					<span>-</span>
					<span>{{ t.to | padLeft: 6 : ' ' }}</span>
					<span
						*ngIf="t.name as name"
						class="text-muted text-sm italic"
						>{{
							name | truncate: 100
						}}</span
					>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template
		#edit
		let-ctrl
		let-ctrlName="name"
	>
		<ng-container formArrayName="items">
			<div [ngClass]="!isWorkspaceSchedule ? '': 'w-2/3' ">
				<tg-target-hour-day-control
					[day]="ctrlName"
					[formControl]="ctrl"
				></tg-target-hour-day-control>
			</div>
		</ng-container>
	</ng-template>
	<ng-template
		#editBase
		let-ctrl
	>
		<div class="flex items-center space-x-4">
			<div class="flex justify-end">
				<button
					(click)="saveItem()"
					[disabled]="control.invalid || itemsError || control.disabled"
					[matTooltip]="'utils.save' | translate"
					class="mat-button-square !rounded-lg"
					mat-button
				>
					<mat-icon>chevron_left</mat-icon>
				</button>
			</div>
			@if(control.controls.enabled.value) {<ng-container
				*ngTemplateOutlet="isWorkspaceSchedule && totalTime"
			></ng-container
			>}
			<mat-form-field
				*ngIf="!isWorkspaceSchedule; else editNameSpacer"
				appearance="fill"
				class="flex-auto"
			>
				<mat-label>Name</mat-label>
				<input
					formControlName="name"
					matInput
				>
			</mat-form-field>
			<div class="flex flex-shrink-0 items-center justify-center space-x-4">
				<div class="mat-bg-5 h-8 w-px flex-shrink-0"></div>
				@if (!isWorkspaceSchedule) {
				<mat-slide-toggle
					[ngClass]="{ 'opacity-80': !ctrl.value.enabled }"
					class="pr-2"
					formControlName="enabled"
				></mat-slide-toggle>
				}
			</div>
		</div>
		<div
			(click.prevent)="openCalPicker()"
			class="flex cursor-pointer flex-col"
		>
			<mat-form-field
				*ngIf="!isWorkspaceSchedule"
				appearance="fill"
				class="pointer-events-none"
			>
				<mat-label>{{ 'schedules.pickStart' | translate }}</mat-label>
				<input
					[disabled]="!!control.controls?.from?.disabled"
					[value]="control.value.from | formatDate"
					class="!pointer-events-none"
					matInput
				>
			</mat-form-field>
		</div>
	</ng-template>
	<ng-template
		#viewBase
		let-ctrl
	>
		<div class="flex flex-col gap-2">
			<div class="flex flex-auto flex-shrink-0 flex-col space-y-3">
				<div class="flex space-x-4 space-y-3">
					<div class="flex flex-auto items-center space-x-2.5">
						<div class="flex flex-col">
							<h1 *ngIf="!isWorkspaceSchedule && ctrl.value?.name as name">{{ name }}</h1>
							<span
								*ngIf="!isWorkspaceSchedule && formatFrom(ctrl.value.from) as d"
								class="mat-hint text-sm"
								>{{
									'schedules.startingFrom' | translate: { date: (d | dfnsFormat: 'PPP') }
								}}</span
							>
							<ng-container
								*ngTemplateOutlet="control.controls.enabled.value ? totalTime : null"
							></ng-container>
						</div>
					</div>
					<div class="flex flex-shrink-0 items-center space-x-4">
						<div class="flex space-x-2">
							<button
								(click)="editItem()"
								[disabled]="ctrl.disabled"
								[matTooltip]="'utils.edit' | translate"
								*ngIf="control.controls.enabled.value"
								class="mat-button-square !rounded-lg"
								mat-button
							>
								<mat-icon>edit</mat-icon>
							</button>
							<button
								[disabled]="ctrl.disabled"
								[matMenuTriggerFor]="editMenu"
								*ngIf="!isWorkspaceSchedule"
								class="mat-button-square !rounded-lg"
								mat-button
							>
								<mat-icon>more_vert</mat-icon>
							</button>
						</div>
						<div class="flex justify-center space-x-4 pt-1">
							<div class="mat-bg-5 h-8 w-px flex-shrink-0"></div>
							@if(!isWorkspaceSchedule) {
							<mat-slide-toggle
								[ngClass]="{ 'opacity-80': !ctrl.value.enabled }"
								class="pr-2"
								formControlName="enabled"
							></mat-slide-toggle>
							}
						</div>
					</div>
				</div>
				<div class="flex items-center justify-between space-x-4 md:w-[560px]">
					@if(control.controls.enabled.value) {
					<div
						[ngClass]="{
					'border-4 border-neutral-600 dark:border-white': d.enabled,
					'border border-neutral-300 dark:border-neutral-600': !d.enabled,
				}"
						*ngFor="let d of ctrl.value.items | slice: 0 : 7; trackProp: 'day'"
						class="pointer-events-none flex h-12 w-[64px] select-none items-center justify-center rounded-lg"
					>
						{{ now | dfnsAddDays: d.day | dfnsFormat: 'iii' }}
					</div>
					}
				</div>
			</div>
		</div>
	</ng-template>
</div>
<mat-menu
	#editMenu="matMenu"
	xPosition="before"
>
	<button
		(click)="cpyItem()"
		[disabled]="control.disabled"
		mat-menu-item
	>
		<mat-icon>content_copy</mat-icon>
		{{ 'utils.copy' | translate }}
	</button>
	<button
		(click)="delItem()"
		[disabled]="control.disabled"
		mat-menu-item
	>
		<mat-icon>delete</mat-icon>
		{{ 'utils.delete' | translate }}
	</button>
</mat-menu>
<ng-template #editNameSpacer>
	<div class="flex flex-auto items-center justify-end">
		<div
			[ngClass]="{ 'mat-hint': !control.value?.enabled }"
			class="mat-typography"
		>
			{{ (control.value?.enabled ? 'utils.enabled' : 'utils.disabled') | translate }}
		</div>
	</div>
</ng-template>
<ng-template #totalTime>
	<ng-container *ngIf="stats$ | async as s">
		<div
			*ngIf="stats$ | async as stats"
			class="mat-hint flex space-x-1 text-sm"
		>
			<div>{{ 'reports.total' | translate }}:</div>
			<div>{{ s.total | parseMsAsDuration }}</div>
		</div>
	</ng-container>
</ng-template>
